module.exports = __webpack_public_path__ + "f34e19c343b0f1cbb109d0e33bf6960c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/iyv-thumbs/wff-thumbnail.jpg
// module id = 1964
// module chunks = 0